<template>
    <v-toolbar class="elevation-2" :dense="dense" :color="color">
        <v-app-bar-nav-icon v-if="icon">
            <v-icon v-if="icon">{{icon}}</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title>{{title}}</v-toolbar-title>

        <v-icon v-if="help" color="grey darken-1" class="ml-4 cursor-pointer" @click="helpDialogModel=true">mdi-information-outline</v-icon>

        <v-spacer></v-spacer>

        <slot name="buttons"></slot>

        <help v-model="helpDialogModel" :identifier="help"></help>
    </v-toolbar>
</template>

<script>

    export default {

        components: {
            Help: () => import('../../modules/Help/components/index')
        },

        props: {
            title: {
                type: String,
                required: true,
                default: 'Anonymous'
            },
            color: {
                type: String,
                required: false,
                default: 'grey darken-4'
            },
            icon: {
                type: String,
                required: false,
                default: null
            },
            disableIcon: {
                type: Boolean,
                required: false,
                default: false
            },
            dense : {
                type: Boolean,
                required: false,
                default: true
            },
            help: {
                type: String,
                required: false,
                default: null
            },
        },

        data() {
            return {
                helpDialogModel: false
            }
        }
    }
</script>
